<template>
  <div class="container">
    <legend>Отчет №3</legend>
    <div class="form-group row mb-3 mx-auto" style="max-width: 400px">
      <div class="col">
        <date-picker class="w-100" v-model="from" valueType="format"
                     placeholder="С"
                     :input-attr="{required: true}"
                     input-class="form-control"
                     :first-day-of-week="1" lang="ru">
        </date-picker>
      </div>
      <div class="col">
        <date-picker class="w-100" v-model="to" valueType="format"
                     placeholder="По"
                     :input-attr="{required: true}"
                     input-class="form-control"
                     :first-day-of-week="1" lang="ru">
        </date-picker>
      </div>
    </div>
    <div class="overflow-auto">
      <table class="table table-bordered table-sm text-center small table-hover" v-if="isLoaded">
        <thead>
        <tr>
          <th rowspan="2" width="100">Отчетная дата</th>
          <th rowspan="2" width="100">Категория</th>
          <th colspan="2" width="200">Отправлено изделий из СПб накануне</th>
          <th colspan="2" width="200">Доставлено изделий</th>
          <th colspan="2" width="200">Оплачено изделий</th>
          <th rowspan="2" width="100">Долг на конец дня нарастающим итогом (руб.)</th>
          <th rowspan="2" width="100">Расходы</th>
          <th rowspan="2" width="100">В кассе (на руках)</th>
        </tr>
        <tr>
          <th>Кол-во (шт.)</th>
          <th>Сумма (руб.)</th>
          <th>Кол-во (шт.)</th>
          <th>Сумма (руб.)</th>
          <th>Кол-во (шт.)</th>
          <th>Сумма (руб.)</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(stats, date) in report.Date">
          <template v-for="(stat, index) in stats">
            <tr>
              <td class="font-weight-bold"><span v-if="index == 0">{{date}}</span></td>
              <td>{{stat.CustomerCategory.Name}}</td>
              <td>{{stat.Stats.OrdersDispatch.CountAmount}}</td>
              <td>{{stat.Stats.OrdersDispatch.CountSummary}}</td>
              <td>{{stat.Stats.OrdersDelivered.CountAmount}}</td>
              <td>{{stat.Stats.OrdersDelivered.CountSummary}}</td>
              <td>{{stat.Stats.OrdersPaid.CountAmount}}</td>
              <td>{{stat.Stats.OrdersPaid.CountSummary}}</td>
              <td>{{stat.Debt[stat.CustomerCategory.Id]}}</td>
              <td></td>
              <td></td>
            </tr>
            <tr class="font-weight-bold" v-if="stats.length - 1 === index">
              <td></td>
              <td>Итого</td>
              <td>{{sumCountAmount(stats, 'OrdersDispatch')}}</td>
              <td>{{sumCountSummary(stats, 'OrdersDispatch')}}</td>
              <td>{{sumCountAmount(stats, 'OrdersDelivered')}}</td>
              <td>{{sumCountSummary(stats, 'OrdersDelivered')}}</td>
              <td>{{sumCountAmount(stats, 'OrdersPaid')}}</td>
              <td>{{sumCountSummary(stats, 'OrdersPaid')}}</td>
              <td>{{sumDebt(stat.Debt)}}</td>
              <td>{{stat.Expense}}</td>
              <td>{{stat.Cash}}</td>
            </tr>
          </template>
        </template>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import _ from 'lodash';
import { get } from '@/admin/services/api/http-utils';

const defaultDateFrom = moment().subtract(5, 'days').format('YYYY-MM-DD');
// const defaultDateFrom = moment().format('YYYY-MM-DD');
const defaultDateTo = moment().format('YYYY-MM-DD');
export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      from: defaultDateFrom,
      to: defaultDateTo,
      report: {},
      isLoaded: false,
    };
  },
  mounted() {
    this.fetchDayReport();
  },
  watch: {
    from(newVal) {
      this.report = {};
      if (newVal) {
        this.fetchDayReport();
      }
    },
    to(newVal) {
      this.report = {};
      if (newVal) {
        this.fetchDayReport();
      }
    },
  },
  computed: {
    // totalStats() {
    //   if (_.isEmpty(this.report)) {
    //     return [];
    //   }
    //
    //   const count = _.map(this.report.Date, (o, i) => {
    //     console.log(o)
    //   });
    //   return count;
    // },
    // CustomerCategories() {
    //   if (!this.report.CategoryStats) {
    //     return [];
    //   }
    //   return _.map(this.report.CategoryStats, CustomerCategory => CustomerCategory.CustomerCategory);
    // },
    // AllDispatched() {
    //   if (_.isEmpty(this.report)) {
    //     return {};
    //   }
    //   const result = {
    //     OrdersDispatch: {
    //       CountOrder: 0,
    //       CountAmount: 0,
    //       Stats: {},
    //     },
    //     OrdersPassed: {
    //       CountOrder: 0,
    //       CountAmount: 0,
    //       Stats: {},
    //     },
    //     OrdersDebtPaid: {
    //       CountOrder: 0,
    //       CountAmount: 0,
    //       Stats: {},
    //     },
    //   };
    //   _.each(this.report.PaymentTypes, (pt) => {
    //     _.each(this.report.CategoryStats, (cs) => {
    //       result.OrdersDispatch.CountOrder += (cs.Stats.OrdersDispatch[pt.Id].CountOrder || 0);
    //       result.OrdersDispatch.CountAmount += (parseInt(cs.Stats.OrdersDispatch[pt.Id].CountAmount) || 0);
    //       result.OrdersDispatch.Stats[pt.Id] = (result.OrdersDispatch.Stats[pt.Id] || 0) + (parseInt(cs.Stats.OrdersDispatch[pt.Id].CountSummary) || 0);
    //
    //       result.OrdersPassed.CountOrder += (cs.Stats.OrdersPassed[pt.Id].CountOrder || 0);
    //       result.OrdersPassed.CountAmount += (parseInt(cs.Stats.OrdersPassed[pt.Id].CountAmount) || 0);
    //       result.OrdersPassed.Stats[pt.Id] = (result.OrdersPassed.Stats[pt.Id] || 0) + (parseInt(cs.Stats.OrdersPassed[pt.Id].CountSummary) || 0);
    //
    //       result.OrdersDebtPaid.CountOrder += (cs.Stats.OrdersDebtPaid[pt.Id].CountOrder || 0);
    //       result.OrdersDebtPaid.CountAmount += (parseInt(cs.Stats.OrdersDebtPaid[pt.Id].CountAmount) || 0);
    //       result.OrdersDebtPaid.Stats[pt.Id] = (result.OrdersDebtPaid.Stats[pt.Id] || 0) + (parseInt(cs.Stats.OrdersDebtPaid[pt.Id].CountSummary) || 0);
    //     });
    //   });
    //   return result;
    // },
    // allDebt() {
    //   const CountOrder = _.sumBy(this.report.categoryStats, cs => _.sumBy(cs.stats.ordersFullDebt, ofd => +ofd.CountOrder));
    //   const CountAmount = _.sumBy(this.report.categoryStats, cs => _.sumBy(cs.stats.ordersFullDebt, ofd => +ofd.CountAmount));
    //   const ptDebts = _.map(this.report.pTypes, pt => _.sumBy(this.report.categoryStats, cs => _.sumBy(cs.stats.ordersFullDebt, (ofd) => {
    //     if (ofd.PaymentTypeId === pt.Id) {
    //       return +ofd.CountSummary;
    //     }
    //     return 0;
    //   })));
    //   return {
    //     CountOrder,
    //     CountAmount,
    //     ptDebts,
    //   };
    // },
    // allPaid() {
    //   const CountOrder = _.sumBy(
    //     this.report.categoryStats, cs => _.sumBy(cs.stats.ordersPaidYesterday, ofd => +ofd.CountOrder) + _.sumBy(cs.stats.ordersDebtYesterday, ofd => +ofd.CountOrder),
    //   );
    //   const CountAmount = _.sumBy(
    //     this.report.categoryStats, cs => _.sumBy(cs.stats.ordersPaidYesterday, ofd => +ofd.CountAmount) + _.sumBy(cs.stats.ordersDebtYesterday, ofd => +ofd.CountAmount),
    //   );
    //   const ptDebts = _.map(
    //     this.report.pTypes, pt => _.sumBy(this.report.categoryStats, cs => _.sumBy(cs.stats.ordersPaidYesterday, (ofd) => {
    //       if (ofd.PaymentTypeId === pt.Id) {
    //         return +ofd.CountSummary;
    //       }
    //       return 0;
    //     })
    //       + _.sumBy(cs.stats.ordersDebtYesterday, (ofd) => {
    //         if (ofd.PaymentTypeId === pt.Id) {
    //           return +ofd.CountSummary;
    //         }
    //         return 0;
    //       })),
    //   );
    //   return {
    //     CountOrder,
    //     CountAmount,
    //     ptDebts,
    //   };
    // },
  },
  methods: {
    sumCountSummary(stats, filedName) {
      return _.sumBy(_.values(stats), o => (o.Stats[filedName] ? +o.Stats[filedName].CountSummary : 0));
    },
    sumCountAmount(stats, filedName) {
      return _.sumBy(_.values(stats), o => (o.Stats[filedName] ? +o.Stats[filedName].CountAmount : 0));
    },
    sumDebt(stats) {
      return _.sumBy(_.values(stats), o => (o ? +o : 0));
    },
    async fetchDayReport() {
      this.isLoaded = false;
      console.log(this.date);
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/stats/day-report2/${this.from}/${this.to}`);
      this.report = data;
      console.log(this.report);
      this.isLoaded = true;
    },
  },
};
</script>
